jQuery(document).ready(function($){

  //Actions au clic sur le Toggle Menu
  $('.sfi-overlay').on('click', function() {
    $('.sfi-overlay').css('visibility','hidden');
    $('.sfi-overlay').css('opacity','0');
    $('.sfi-navbar--nav_toggler').removeClass('sfi-cross');
    $('.sfi-navbar--nav_toggler').attr('aria-expanded','false');
    $('body').css('overflow','auto');
    $('.sfi-navbar--menu').removeClass('show');
  });

  $('.sfi-navbar--nav_toggler').on('click',function(){
    //Barre top qui passe dans le menu mobile pour éviter de le dupliquer
    var barreTop = $('.sfi-navbar--top');
    $('#navbarNavDropdown').append(barreTop);
    $(barreTop).css('display','block');

    //Overlay
    if($(this).attr('aria-expanded') == 'true'){
      $('.sfi-overlay').css('visibility','hidden');
      $('.sfi-overlay').css('opacity','0');
      $(this).removeClass('sfi-cross');
      $('body').css('overflow','auto');
      // $('.sfi-overlay').css('width','0');
    } else {
      $('.sfi-overlay').css('visibility','visible');
      $('.sfi-overlay').css('opacity','1');
      $('body').css('overflow','hidden');
      $(this).addClass('sfi-cross');
      // $('.sfi-overlay').css('width','100%');
    }
  });

  //Permet d'ajuster dynamiquement la marge au dessus du body par rapport au menu
  var menuHeight = $('.sfi-navbar').outerHeight();
  $('.sfi-body').css('margin-top',menuHeight);
  if($(window).width() < 992){
    $('#navbarNavDropdown').css('padding-top',menuHeight);
  }

  //On gère les sous menus
  $('li.menu-item').on('click',function(){
    if($(window).width() < 992) {
      if($(this).hasClass('menu-item-has-children')){
        if($(this).hasClass('show')) {
          $(this).removeClass('show');
          $(this).find('.sub-menu').removeClass('show');
        } else {
          $(this).addClass('show');
          $(this).find('.sub-menu').addClass('show');
        }

      }
    }
  })

  //Pour cacher le bandeau top au scroll
  var scrollPos = $(window).scrollTop() ;
  $(window).on('scroll', function() {
    var currentPos = $(window).scrollTop() ;
    // console.log(currentPos);
    if ( ($(window).width() > 992) && ($('.sfi-navbar--top').length > 0) ) {
      if ( currentPos > 40 ) {
        $('.sfi-navbar--top').addClass('hide');
      } else {
        $('.sfi-navbar--top').removeClass('hide');
      }

    } else if ($(window).width() < 768 ) {
      if ( currentPos > scrollPos && scrollPos > 15) {
          $('.sfi-navbar--nav').addClass('small') ;
        } else {
          $('.sfi-navbar--nav').removeClass('small') ;
        }
    }

    scrollPos = currentPos ;
  });


    if($(window).width() < 992) {
      $('.sfi-navbar--top_search #search').on('focus',function(){
        $('.sfi-navbar--nav_toggler').css('display','none');
        $('.sfi-navbar--menu').css('padding-top','10px');
      });

      $('.sfi-navbar--top_search #search').on('blur',function(){
        $('.sfi-navbar--nav_toggler').css('display','block');
        $('.sfi-navbar--menu').css('padding-top','95px');
      });
    }

});
